export const isProd = process.env.NODE_ENV === "production";

export const isClientSide = process.browser;

export const isServer = () => {
  return typeof window === "undefined";
};
